// some files are broken/corrupt, and the 
// viewer libraries can crash when they try to open them. This 
// wraps each viewer in a "catch net" so one bad file shows a 
// small error card 
// instead of freezing or blanking the whole page.

import React from 'react';

interface ErrorBoundaryProps {
  fallback: (error: Error) => React.ReactNode;
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

// Renderers are third-party parsers fed arbitrary bytes from a SAS URL — a
// malformed or unexpected file throws, and that throw must not take the
// whole preview pane down. DocPreviewShell keys this by the document's
// identity, so switching documents remounts it with a clean state rather
// than needing an explicit reset method.
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[doc-preview] renderer crashed:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return this.props.fallback(this.state.error);
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
